module.exports = __webpack_public_path__ + "img/investigate.7fcc0230.svg";